(function (Drupal, once) {
  function getItems(grid) {
    return Array.from(grid.children).filter((el) =>
      el.classList.contains('field__item') && !el.classList.contains('field__item--spacer')
    );
  }

  function removeSpacer(grid) {
    grid.querySelectorAll('.field__item--spacer').forEach((el) => el.remove());
  }

  function getColumnData(grid) {
    const items = getItems(grid);
    const tolerance = 10;
    const columns = [];

    items.forEach((item) => {
      const rect = item.getBoundingClientRect();
      const left = Math.round(rect.left);
      const bottom = Math.round(rect.bottom);

      let column = columns.find((col) => Math.abs(col.left - left) <= tolerance);

      if (!column) {
        column = {
          left,
          bottom,
          items: [item]
        };
        columns.push(column);
      } else {
        column.items.push(item);
        if (bottom > column.bottom) {
          column.bottom = bottom;
        }
      }
    });

    columns.sort((a, b) => a.left - b.left);
    return columns;
  }

  function addSpacerToShorterColumn(grid) {
    removeSpacer(grid);

    const columns = getColumnData(grid);
    if (columns.length !== 2) {
      return;
    }

    const maxBottom = Math.max(columns[0].bottom, columns[1].bottom);
    const shorter = columns.find((col) => col.bottom < maxBottom);

    if (!shorter) {
      return;
    }

    const diff = maxBottom - shorter.bottom;
    if (diff < 2) {
      return;
    }

    const spacer = document.createElement('div');
    spacer.className = 'field__item field__item--spacer';
    spacer.setAttribute('aria-hidden', 'true');
    spacer.style.height = `${diff}px`;

    grid.appendChild(spacer);
  }

  function layoutWithSpacer(grid) {
    if (typeof MasonIt === 'undefined') {
      return;
    }

    removeSpacer(grid);
    MasonIt.refresh(grid);

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        addSpacerToShorterColumn(grid);
        MasonIt.refresh(grid);
      });
    });
  }

  Drupal.behaviors.adocsMasonIt = {
    attach(context) {
      once('adocs-mason-it', '.masonry-container', context).forEach((grid) => {
        if (typeof MasonIt === 'undefined') {
          return;
        }

        MasonIt.init(grid, {
          masonDelay: 100,
          masonPollInterval: 0
        });

        layoutWithSpacer(grid);

        window.addEventListener('load', () => {
          layoutWithSpacer(grid);
        }, { once: true });

        let resizeTimer;
        window.addEventListener('resize', () => {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(() => {
            layoutWithSpacer(grid);
          }, 150);
        });

        if ('ResizeObserver' in window) {
          const ro = new ResizeObserver(() => {
            layoutWithSpacer(grid);
          });

          ro.observe(grid);
          getItems(grid).forEach((item) => ro.observe(item));
        }

        grid.querySelectorAll('img').forEach((img) => {
          if (!img.complete) {
            img.addEventListener('load', () => layoutWithSpacer(grid), { once: true });
            img.addEventListener('error', () => layoutWithSpacer(grid), { once: true });
          }
        });
      });
    }
  };
})(Drupal, once);
